/**
 * Fishing calculation utilities
 */

import { PlayerStats } from '@/types';
import { BALANCE_CONFIG } from '@/data';

/**
 * Calculate effective fishing time with all bonuses
 */
export function calculateFishingTime(
  baseTime: number,
  playerStats: PlayerStats,
  buddyMultiplier: number = 1.0
): number {
  // Apply player speed bonus
  let time = baseTime * (1 - playerStats.fishingSpeed);

  // Apply buddy penalty if applicable
  time *= buddyMultiplier;

  // Apply floor
  time = Math.max(time, BALANCE_CONFIG.MIN_FISHING_TIME);

  return time;
}

/**
 * Calculate effective catch chance with all bonuses
 */
export function calculateCatchChance(
  baseChance: number,
  playerStats: PlayerStats,
  buddyReduction: number = 0
): number {
  // Apply player bonus
  let chance = baseChance + playerStats.catchChance;

  // Apply buddy penalty if applicable
  chance -= buddyReduction;

  // Clamp to valid range
  chance = Math.max(0, Math.min(BALANCE_CONFIG.MAX_CATCH_CHANCE, chance));

  return chance;
}

/**
 * Calculate sell value with all multipliers
 */
export function calculateSellValue(
  baseValue: number,
  qualityMultiplier: number,
  buyerMultiplier: number,
  playerValueBonus: number = 0
): number {
  return baseValue * qualityMultiplier * buyerMultiplier * (1 + playerValueBonus);
}
